import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title: "Cybersäkerhet börjar med dig",
  header: "Cybersäkerhet börjar med dig",
  date: "2025-07-25",
  description:
    "Varför teknik inte räcker – och hur enkla vardagsrutiner i teamet minskar risken för intrång.",
  category: "säkerhet",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
